// extracted by mini-css-extract-plugin
export default {"root":"ClockDigitContainer_root__amzyu","container":"ClockDigitContainer_container__wy+MR"};